var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "frame-extras" },
    [
      _c("tab-heading", _vm._g({}, _vm.$listeners), [
        _c("h2", { staticClass: "text-center" }, [_vm._v("Frame Extras")]),
        _c("p", { staticClass: "lead text-center mb-1" }, [
          _vm._v("Choose extras for your frame:"),
        ]),
        _c("p", { staticClass: "text-center font-italic mb-0" }, [
          _vm._v(
            "Please note that if you have selected mount or glass, we must provide backing board to deliver."
          ),
        ]),
      ]),
      _c(
        "b-row",
        { staticClass: "mb-1 py-3" },
        [
          _c("b-col", { attrs: { md: "3" } }, [
            _c("h4", { staticClass: "border-left p-3 extra-type" }, [
              _vm._v("Standard Extras"),
            ]),
          ]),
          _c(
            "b-col",
            [
              _c("frame-extra", {
                staticClass: "bg-light",
                attrs: {
                  name: "Backing Board",
                  "price-endpoint": "/api/pricing/sheets/inFrame",
                  sku: "B-17",
                  dimensions: _vm.glassDimensions,
                  warning: _vm.backingWarning,
                },
                scopedSlots: _vm._u([
                  {
                    key: "product-info",
                    fn: function () {
                      return [
                        _c("p", [
                          _vm._v(
                            "A lightweight brown backing board. Easy to cut to size and good value for money, it is a very popular choice for picture framers."
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selectedExtras.backing,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedExtras, "backing", $$v)
                  },
                  expression: "selectedExtras.backing",
                },
              }),
              _c("frame-extra", {
                attrs: {
                  name: "Fixings (2 D-Rings and String to hang)",
                  "price-endpoint": "/api/pricing/frame/fixings",
                  dimensions: _vm.rebateDimensions,
                },
                scopedSlots: _vm._u([
                  {
                    key: "product-info",
                    fn: function () {
                      return [
                        _c("p", [
                          _vm._v(
                            "Quality picture frame D-rings and string to hang your frame on a wall."
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selectedExtras.fixings,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedExtras, "fixings", $$v)
                  },
                  expression: "selectedExtras.fixings",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "mb-1 py-3" },
        [
          _c("b-col", { attrs: { md: "3" } }, [
            _c("h4", { staticClass: "border-left p-3 extra-type" }, [
              _vm._v("Additional Extras"),
            ]),
          ]),
          _c(
            "b-col",
            [
              _c("frame-extra", {
                staticClass: "bg-light",
                attrs: {
                  name: "White Larson-Juhl Undermount (1400mc)",
                  "price-endpoint": "/api/pricing/sheets/inFrame",
                  "validation-endpoint": "/api/validation/sheets/manufacture",
                  sku: "UM-61",
                  dimensions: _vm.glassDimensions,
                },
                scopedSlots: _vm._u([
                  {
                    key: "product-info",
                    fn: function () {
                      return [
                        _c("p", [
                          _vm._v(
                            "Whitecore 1400 Micron thick mountboard. This mountboard meets the FATG Standard level, and is suitable for mounting your artwork onto. \nThis is to be used as a barrier between the artwork and the backing board, and you should mount your artwork onto this board."
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selectedExtras.undermount,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedExtras, "undermount", $$v)
                  },
                  expression: "selectedExtras.undermount",
                },
              }),
              _c("frame-extra", {
                attrs: {
                  name: "1.5mm Permanent Sticky Fastmount",
                  "price-endpoint": "/api/pricing/sheets/inFrame",
                  "validation-endpoint": "/api/validation/sheets/manufacture",
                  sku: "B-58",
                  dimensions: _vm.glassDimensions,
                },
                scopedSlots: _vm._u([
                  {
                    key: "product-info",
                    fn: function () {
                      return [
                        _c("p", [
                          _vm._v(
                            "A superb solution to mounting a photo for framing in a photo frame/picture frame to avoid the common problem of cockling. Cockling describes a photo, print or artwork on paper that has rippled, it has undulations across the paper, it has basically absorbed moisture and then dried out. \nPhotos or thinner papers tend to easily cockle easily and leaves a very distracting pattern that can ruin a photo/print."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "Larson-Juhl Permanent Fastmount is a very good quality self adhesive mounting board. This is a professional mounting board used for dry mounting. \nPlease note: once something has been stuck onto fastmount, it will be stuck onto the board permanently."
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selectedExtras.fastmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedExtras, "fastmount", $$v)
                  },
                  expression: "selectedExtras.fastmount",
                },
              }),
              _c("frame-extra", {
                staticClass: "bg-light",
                attrs: {
                  name: "1.5mm Spacer",
                  "price-endpoint": "/api/pricing/frame/spacer",
                  dimensions: _vm.rebateDimensions,
                },
                scopedSlots: _vm._u([
                  {
                    key: "product-info",
                    fn: function () {
                      return [
                        _c("p", [
                          _vm._v(
                            "A pH neutral plastic spacer with a self-adhesive backing, ideal for creating airspace between the glass and the artwork."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "A spacer is recommended for when you are framing art without a mount, as it will keep the artwork away from the glass."
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selectedExtras.spacer,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedExtras, "spacer", $$v)
                  },
                  expression: "selectedExtras.spacer",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }